// src/pages/work-order-management-system/components/hooks/useBudgetTotals.js
import { useMemo, useState } from 'react';

const IVA_RATE = 0.16;
// 1.92% expresado como factor decimal
const ISR_RATE = 0.0192; // 1.92%, se suma

/**
 * Calcula subtotales, impuestos y total de la orden
 * y maneja los switches de IVA / ISR.
 **/
export const useBudgetTotals = (refacciones, servicios) => {
    const [incluirIVA, setIncluirIVA] = useState(true);
    const [incluirISR, setIncluirISR] = useState(false);

    const calculosOrden = useMemo(() => {
        const subtotalRefacciones = refacciones.reduce(
            (acc, ref) => acc + (Number(ref.total) || 0),
            0
        );

        const subtotalServicios = servicios.reduce(
            (acc, serv) => acc + (Number(serv.total) || 0),
            0
        );

        const subtotal = subtotalRefacciones + subtotalServicios;

        const iva = incluirIVA ? subtotal * IVA_RATE : 0;
        const isr = incluirISR ? subtotal * ISR_RATE : 0;

        // Se suma todo al subtotal
        const total = subtotal + iva + isr;

        return {
            subtotalRefacciones,
            subtotalServicios,
            subtotal,
            iva,
            isr,
            total
        };
    }, [refacciones, servicios, incluirIVA, incluirISR]);

    return {
        incluirIVA,
        setIncluirIVA,
        incluirISR,
        setIncluirISR,
        calculosOrden
    };
};
